import { formatDate } from './dateUtils';

/**
 * Resolves the 1-based day number from a day entity.
 * @param {Object|null|undefined} day
 * @returns {number|null}
 */
export function resolveDayNumber(day) {
  if (!day) {
    return null;
  }

  if (typeof day.dayNumber === 'number' && day.dayNumber > 0) {
    return day.dayNumber;
  }

  if (typeof day.order === 'number' && day.order >= 0) {
    return day.order + 1;
  }

  return null;
}

/**
 * Formats a day label for UI presentation, e.g. "Day 3 - Mon 03 Aug 2026".
 * @param {Object|null|undefined} day
 * @param {{ fallbackName?: string }} [options]
 * @returns {string}
 */
export function formatDayDisplayLabel(day, { fallbackName } = {}) {
  if (!day) {
    return fallbackName || 'Day';
  }

  const dayNumber = resolveDayNumber(day);
  const date = day.date || day.details?.date || null;
  const formattedDate = date ? formatDate(date) : null;
  const hasFormattedDate = formattedDate
    && formattedDate !== 'Date not set'
    && formattedDate !== 'Invalid Date';

  if (day.title) {
    if (hasFormattedDate && !String(day.title).includes(formattedDate)) {
      return `${day.title} - ${formattedDate}`;
    }
    return day.title;
  }

  if (dayNumber && hasFormattedDate) {
    return `Day ${dayNumber} - ${formattedDate}`;
  }

  if (dayNumber) {
    return `Day ${dayNumber}`;
  }

  if (hasFormattedDate) {
    return formattedDate;
  }

  return fallbackName || 'Day';
}
